/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const companyRolesAttributesDtoRolesEnum = {
    "Project executive": "Project executive",
    "Project manager": "Project manager",
    "Project administrator": "Project administrator",
    "Operations manager": "Operations manager",
    "Lawyer/Counsel": "Lawyer/Counsel",
    "Paralegal": "Paralegal",
    "Risk manager": "Risk manager",
    "Administrative support": "Administrative support",
    "Architect": "Architect",
    "Engineer": "Engineer",
    "Estimator": "Estimator",
    "Preconstruction manager": "Preconstruction manager",
    "Procurement": "Procurement",
    "Field operations / Superintendent": "Field operations / Superintendent",
    "Quality": "Quality",
    "Safety professional": "Safety professional",
    "Business development / Sales": "Business development / Sales",
    "Other": "Other"
} as const;

export type CompanyRolesAttributesDtoRolesEnumKey = (typeof companyRolesAttributesDtoRolesEnum)[keyof typeof companyRolesAttributesDtoRolesEnum];

export type CompanyRolesAttributesDto = {
    /**
     * @description List of predefined company roles available for selection
     * @type array
    */
    roles: CompanyRolesAttributesDtoRolesEnumKey[];
};